"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var getTopDomain_1 = __importDefault(require("./getTopDomain"));
var COOKIE_NAME = 'ps-mem-token';
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.inMemory = true;
        this._storage = {};
        this._keys = new Set();
    }
    MemoryStorage.getIsEnabled = function () {
        return Boolean(js_cookie_1.default.get(COOKIE_NAME, {
            domain: (0, getTopDomain_1.default)()
        }));
    };
    MemoryStorage.enableOnTopDomain = function () {
        js_cookie_1.default.set(COOKIE_NAME, '1', {
            domain: (0, getTopDomain_1.default)(),
            expires: 1
        });
    };
    MemoryStorage.prototype.revise = function () {
        var _this = this;
        this._keys.forEach(function (key) {
            if (_this._storage[key] === undefined) {
                delete _this[key];
            }
        });
        Object.assign(this, this._storage);
    };
    MemoryStorage.prototype.getItem = function (key) {
        return this._storage[key];
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        this._keys.add(key);
        this._storage[key] = String(value);
        this.revise();
    };
    MemoryStorage.prototype.removeItem = function (key) {
        this._keys.delete(key);
        delete this._storage[key];
        delete this[key];
    };
    MemoryStorage.prototype.clear = function () {
        var _this = this;
        this._keys.forEach(function (key) {
            delete _this[key];
        });
        this._storage = {};
        this._keys.clear();
    };
    MemoryStorage.prototype.key = function (index) {
        return this._keys[index];
    };
    MemoryStorage.prototype.keys = function () {
        return __spreadArray([], Array.from(this._keys), true);
    };
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () {
            return this._keys.size;
        },
        enumerable: false,
        configurable: true
    });
    return MemoryStorage;
}());
exports.default = MemoryStorage;
//# sourceMappingURL=MemoryStorage.js.map